import { Autorenew, ContentPaste, Edit, Info } from "@mui/icons-material";
import { Button, IconButton, TableCell, Tooltip } from "@mui/material";
import { GetAppointment } from "../../../../../services/fhir";
import { useFhirData } from "../../../../../utils/useFhirData";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { useOrganizationContext } from "../../../../../contexts/OrganizationContext";
import { useClinicalRegisterContext } from "../../../../../contexts/ClinicalRegisterContext";
import { useEhrRecordsMobileLayout } from "../../../context/EhrRecordsLayoutContext";
import {
  EhrMobileActionStack,
  ehrMobileActionBtnSx,
} from "../../mobile/EhrMobileActionStack";

interface IProps {
  row: any;
  openVisualizer: any;
  verifyVisualizer: any;
}

export function ClinicalEncounterActions({
  row,
  openVisualizer,
  verifyVisualizer,
}: IProps) {
  const { user } = useSessionContext();
  const { organization } = useOrganizationContext();
  const { verifyEncounter } = useClinicalRegisterContext();
  const isEhrMobileCard = useEhrRecordsMobileLayout();

  const practitioner = useFhirData?.findParticipant(
    row?.participant,
    "Practitioner"
  );

  const canEdit =
    practitioner?.reference?.includes(user?.username) &&
    row?.organizationId === organization?.id?.split("-")?.[1];

  const resumeEncounter = async () => {
    const appointment = await GetAppointment({
      ehrrunner: row?.subject,
      _id: row?.appointmentId,
    });

    if (appointment?.entry?.[0]?.resource) {
      await verifyEncounter(appointment?.entry?.[0]?.resource);
    }
  };

  const hasVisualizer = verifyVisualizer && verifyVisualizer(row?.encounterId);
  const canResume =
    verifyVisualizer &&
    !verifyVisualizer(row?.encounterId) &&
    canEdit;

  if (isEhrMobileCard) {
    const hasActions =
      hasVisualizer ||
      (row?.status !== "completed" && (canResume || !hasVisualizer));

    if (!hasActions) return null;

    return (
      <EhrMobileActionStack>
        {hasVisualizer ? (
          <>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              startIcon={<ContentPaste />}
              sx={ehrMobileActionBtnSx}
              onClick={() => {
                openVisualizer(row?.encounterId);
              }}
            >
              Visualizar atendimento
            </Button>

            {canEdit ? (
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                startIcon={<Edit />}
                sx={ehrMobileActionBtnSx}
                onClick={resumeEncounter}
              >
                Editar atendimento
              </Button>
            ) : null}
          </>
        ) : row?.status !== "completed" ? (
          <>
            <Button
              fullWidth
              variant="outlined"
              color="info"
              startIcon={<Info />}
              sx={ehrMobileActionBtnSx}
              disabled
            >
              Atendimento não finalizado
            </Button>

            {canResume ? (
              <Button
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<Autorenew />}
                sx={ehrMobileActionBtnSx}
                onClick={resumeEncounter}
              >
                Retomar atendimento
              </Button>
            ) : null}
          </>
        ) : null}
      </EhrMobileActionStack>
    );
  }

  return (
    <TableCell align="center">
      {hasVisualizer ? (
        <>
          <Tooltip title="Visualizar atendimento">
            <IconButton
              onClick={() => {
                openVisualizer(row?.encounterId);
              }}
            >
              <ContentPaste />
            </IconButton>
          </Tooltip>

          {canEdit ? (
            <Tooltip title="Editar atendimento">
              <IconButton onClick={resumeEncounter}>
                <Edit />
              </IconButton>
            </Tooltip>
          ) : null}
        </>
      ) : (
        <>
          {row?.status !== "completed" ? (
            <>
              <Tooltip title="Este atendimento não foi finalizado corretamente. Lembre-se de concluir os atendimentos futuros clicando no botão de finalização.">
                <IconButton onClick={() => {}}>
                  <Info sx={{ color: "#0000a7" }} />
                </IconButton>
              </Tooltip>

              {canResume ? (
                <Tooltip title="Retomar atendimento">
                  <IconButton onClick={resumeEncounter}>
                    <Autorenew />
                  </IconButton>
                </Tooltip>
              ) : null}
            </>
          ) : null}
        </>
      )}
    </TableCell>
  );
}
